import clsx from 'clsx';

import { statusLabel, statusTone, type SubscriptionInfo } from '@/lib/subscription';

const TONES = {
  green: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  amber: 'bg-amber-50 text-amber-700 border-amber-200',
  red: 'bg-rose-50 text-rose-700 border-rose-200',
  slate: 'bg-ink/5 text-ink/60 border-line',
} as const;

export default function StatusPill({ sub }: { sub: SubscriptionInfo | null }) {
  if (!sub) {
    return (
      <span className={clsx('inline-flex items-center whitespace-nowrap rounded-md border px-2 py-0.5 text-[11px] font-medium', TONES.slate)}>
        Нет подписки
      </span>
    );
  }
  return (
    <span
      className={clsx(
        'inline-flex items-center whitespace-nowrap rounded-md border px-2 py-0.5 text-[11px] font-medium',
        TONES[statusTone(sub)],
      )}
    >
      {statusLabel(sub)}
    </span>
  );
}
